import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import ThreadList from '@components/threadList';
import DownloadApp from '@components/downloadApp';
import SidebarTopicList from '@components/sidebarTopicList';
import SidebarUserInfo from '@components/sidebarUserInfo';
import { Carousel } from 'antd';
import Avatar from '@components/avatar';
import { CommonAction } from '@stores/common/action';
import updateImageListSrc from '@utils/update-image-list-src'


interface HomePCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    threadList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    userInfo?: any;
    thread?: ThreadAction;
    common?: CommonAction;
}
interface HomePCPageState {
    bannerList?: any;
    loading: boolean;
    error: any
    pageLoaded: any
    topicList?: any
    isChanging: boolean;
}

@inject('app', 'site', 'user', 'thread', 'common')
@observer
class HomePCPage extends BasePage<HomePCPageProps, HomePCPageState> {
    changeTimer:any = null;
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        bannerList: [], // banner列表
        topicList: [],  // 话题列表
        isChanging: false
    };

    componentDidMount() {
        const { app, user, thread, common } = this.props;
        
        // if (thread) {
        //     let params: any = {
        //         "page[number]": 1,
        //         "page[size]": 20
        //     }
        //     thread.getThreadList(params)
        // }
        if(common) {
            let bannerParams = {
                type: 1,
                category: 1
            }
            common.getBannerList(bannerParams).then((res) => {
                this.setState({
                    bannerList: res.data?.list
                })
            });
            
            
        }
        super.componentDidMount();
    }

    componentWillUnmount() {
        // 组件卸载时清理定时器
        if (this.changeTimer) {
            clearTimeout(this.changeTimer);
        }
    }

    // 处理轮播图切换前的回调
    handleBeforeChange = () => {
        this.setState({ isChanging: true });
        
        // 清理之前的定时器
        if (this.changeTimer) {
            clearTimeout(this.changeTimer);
        }
        
        // 设置50ms后重置isChanging状态
        this.changeTimer = setTimeout(() => {
            this.setState({ isChanging: false });
        }, 50);
    }

    // 处理图片点击事件
    handleImageClick = (data) => {
        if (!this.state.isChanging) {
            window.location.href = data.targe_url?.[1]?.url;;
        }
    }

    // 跳转到话题详情页
    handleTopicClick = (id: string | number) => {
        this.props.history && this.props.history.push(`/topic/${id}`);
    };

    // 帖子列表
    renderThreadList = () => {
        const { threadList, loading, hasMore, onLoadMore } = this.props;
        // console.log('[PC] threadList:', threadList);
        // console.log('[PC] loading:', loading);
        // console.log('[PC] hasMore:', hasMore);
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList data={threadList} showRecommendUserList={true} loading={loading} hasMore={hasMore} onLoadMore={onLoadMore}></ThreadList>
                {/* {loading && <div className={styles.loading}>加载中...</div>}
                {!hasMore && !loading && <div className={styles.loading}>没有更多了</div>} */}
            </div>
        )
    }

    // 首页左侧侧内容
    readerLeft = () => {
        let { bannerList } = this.state;
        return (
            <div className={styles.leftContent}>
                <div className={styles.carouselBox}>
                    <Carousel autoplay={true}
                        autoplaySpeed={2000}
                        draggable={true}
                        className={styles.CarouselList}
                        dots={{ className: styles.customDots }}
                        beforeChange={this.handleBeforeChange}
                    >
                        {bannerList?.map((item: any) => (
                            <img
                                src={updateImageListSrc(item.img_url, 24)}
                                className={styles.carouselImg}
                                onClick={() => this.handleImageClick(item)}
                            />
                        ))}
                    </Carousel>
                </div>
                {this.renderThreadList()}
            </div>
        );
    }

    // 首页右侧内容
    readerRight = () => {
        let { topicList } = this.state;
        // let isLogin = false;
        return (
            <div className={styles.rightContent}>
                {/* 用户信息 */}
                <SidebarUserInfo></SidebarUserInfo>
                {/* 下载app */}
                <DownloadApp></DownloadApp>
                {/* 热门话题 */}
                <SidebarTopicList></SidebarTopicList>
                
            </div>
        );
    }

    render() {
        const { app } = this.props;

        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (<div className={styles.wrapper}>
                {this.readerLeft()}
                {this.readerRight()}
            </div>)
        }

    }
}

export default withRouter(HomePCPage);
